import { isString } from '../../shared/utils'

const getQueryParamsObj = (): URLSearchParams => {
  const queryString = window.location.search
  return new URLSearchParams(queryString)
}

const hasQueryParam = (key: string): boolean => {
  return getQueryParamsObj().has(key)
}

const getQueryParam = (key: string): string | null => {
  const paramsObj = getQueryParamsObj().get(key)
  if (isString(paramsObj)) return decodeURI(paramsObj)
  return null
}

const getHashParamsObj = (): URLSearchParams => {
  const queryString = window.location.hash.replace('#', '&')
  return new URLSearchParams(queryString)
}

const hasHashParam = (key: string): boolean => {
  return getHashParamsObj().has(key)
}

const getHashParam = (key: string): string | null => {
  const paramsObj = getHashParamsObj().get(key)
  if (isString(paramsObj)) return decodeURI(paramsObj)
  return null
}

const clearAllParams = (): string => {
  history.replaceState(null, '', window.location.pathname)
  window.location.hash = ''
  return location.href
}

const checkUrlQueryParams = (params: string[]): boolean => {
  return params.every((param) => {
    return hasQueryParam(param)
  })
}

const checkUrlHashParams = (params: string[]): boolean => {
  return params.every((param) => {
    return hasHashParam(param)
  })
}

const isCookieEnabled = (): boolean => {
  if (navigator.cookieEnabled) return true

  // setea y borra una cookie para navegadores antiguos que no tienen el
  // api navigator
  document.cookie = 'cookietest=1'
  const isSetted = document.cookie.includes('cookietest=')
  // delete cookie
  document.cookie =
    'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'

  return isSetted
}

const isSessionStorageAvailable = (): boolean => {
  return typeof sessionStorage !== 'undefined'
}

const isLocalStorageAvailable = (): boolean => {
  return typeof localStorage !== 'undefined'
}

const urlUtils = {
  getQueryParamsObj,
  hasQueryParam,
  getQueryParam,
  clearAllParams,
  checkUrlQueryParams,
  getHashParamsObj,
  hasHashParam,
  getHashParam,
  checkUrlHashParams,
}

export {
  urlUtils,
  isCookieEnabled,
  isSessionStorageAvailable,
  isLocalStorageAvailable,
}
